module.exports = __webpack_public_path__ + "img/bg2.76c1b456.png";